import { ModuleItemType } from '@app/store/shared';
import { LearningPortfolioContextDto } from './learning-portfolio.dto';

export class LearningPortfolioContext {
    readonly pathwayId?: string;
    readonly pathwayName?: string;
    readonly courseId?: string;
    readonly courseName?: string;
    readonly moduleId?: string;
    readonly moduleName?: string;
    readonly itemId?: string;
    readonly itemType?: ModuleItemType;
    readonly itemName?: string;

    constructor(dto: LearningPortfolioContextDto) {
        this.pathwayId = dto.pathwayId;
        this.pathwayName = dto.pathwayName;
        this.courseId = dto.courseId;
        this.courseName = dto.courseName;
        this.moduleId = dto.moduleId;
        this.moduleName = dto.moduleName;
        this.itemId = dto.itemId;
        this.itemType = dto.itemType;
        this.itemName = dto.itemName;
    }
}
